import { useState, FC } from 'react'
import PerText from '../../../components/custom_components/Text'
import { useTranslation } from 'react-i18next'
import { PerModal } from '../../../components/custom_components/Modal'
import TextArea from 'antd/lib/input/TextArea'

interface MeetingCancelModalProps {
  isOpen: boolean
  onClose: () => void
  onCancelMeeting: (reasonForMeetingCancel: string) => Promise<boolean>
}
export const MeetingCancelModal: FC<MeetingCancelModalProps> = ({ isOpen, onClose, onCancelMeeting }) => {
  const { t } = useTranslation()
  const [reasonForMeetingCancel, setReasonForMeetingCancel] = useState('')
  const [isSubmitting, toggleSubmitting] = useState<boolean>(false)
  const [hasError, toggleError] = useState<boolean>(false)

  const cancelMeeting = async (reasonForMeetingCancel: string): Promise<void> => {
    toggleSubmitting(true)
    const error = await onCancelMeeting(reasonForMeetingCancel)
    toggleError(error)
    toggleSubmitting(false)
  }

  return (
    <>
      <PerModal
        title={{ heading: t('managerMeetings.cancelMeetingModal.header') }}
        size="small"
        centered
        visible={isOpen}
        onCancel={(_) => {
          onClose()
          setReasonForMeetingCancel('')
        }}
        footer={{
          cancelBtn: {
            onClick: (_) => {
              onClose()
              setReasonForMeetingCancel('')
            },
          },
          customBtns: [
            {
              text: t('managerMeetings.cancelMeetingModal.confirm'),
              onClick: async () => {
                await cancelMeeting(reasonForMeetingCancel)
                setReasonForMeetingCancel('')
              },
              color: 'error',
              icon: 'delete_fill',
              disabled: !reasonForMeetingCancel,
              isProcessing: { active: isSubmitting },
            },
          ],
        }}
      >
        <PerText mb="s">{t('managerMeetings.cancelMeetingModal.description')} </PerText>
        <PerText mb="s">{t('managerMeetings.cancelMeetingModal.description1')} </PerText>
        <TextArea
          value={reasonForMeetingCancel}
          placeholder={t('managerMeetings.cancelMeetingModal.placeholder')}
          onChange={(e) => {
            e.preventDefault()
            setReasonForMeetingCancel(e.target.value)
          }}
        ></TextArea>
        {hasError && (
          <PerText color="error" fontSize="m" mt="m">
            {t('managerMeetings.cancelMeetingModal.error')}
          </PerText>
        )}
      </PerModal>
    </>
  )
}
